import SecondaryAdvanceSettingsViewController from "../../ui-components/usercentrics-button/privacy-views/secondary-advance-privacy-view/settings/settings-view-controller";

export class MoreInfoEventsService {
    private eventNumber: any;

    private eventMapper: any = {
        1: 'open-consent-info-modal',
        2: 'open-url-new-frame',
        3: 'open-corner-model',
        4: 'open-central-model',
        5: 'open-central-model-no-closeable',
        6: 'open-url-new-tab',
        7: 'open-corner-model-preselect'
    };
    private utilityService: any;
    constructor(utilityService) {
        this.utilityService = utilityService;
    }

    initMoreInfoEvent() {
        this.eventNumber = this.utilityService.settingsService.moreInfoEvent;
        this.moreInfoCustomEvent(this.utilityService.settingsService.settings.moreInfoButtonUrl);
    }

    openConsentInfoModal(id?) {
        this.eventNumber = this.utilityService.settingsService.settings.consentInfoActionSelection;
        this.moreInfoCustomEvent(this.utilityService.settingsService.settings.urlConsentInfo, id);
    }

    public moreInfoCustomEvent(url, id?) {
        switch (this.eventMapper[this.eventNumber]) {
            case 'open-url-new-tab':
                MoreInfoEventsService.url(url);
                break;
            case 'open-corner-model':
                this.utilityService.UserCentricViewController.privacyCornerModal.openModal();
                break;
            case 'open-url-new-frame':
                this.utilityService.UserCentricViewController.openAboutModal(url);
                break;
            case 'open-central-model':
                this.utilityService.UserCentricViewController.privacyCenterModal.updateCloseIconVisibility(true);
                this.utilityService.UserCentricViewController.privacyCenterModal.visible = true;
                break;
            case 'open-central-model-no-closeable':
                this.utilityService.UserCentricViewController.privacyCenterModal.updateCloseIconVisibility(false);
                this.utilityService.UserCentricViewController.privacyCenterModal.visible = true;
                break;
            case 'open-corner-model-preselect':
                SecondaryAdvanceSettingsViewController.updateSelectedNotsaved(
                    true
                );
                this.utilityService.UserCentricViewController.privacyCornerModal.openModal();
                break;
            case 'open-consent-info-modal':
            default:
                this.utilityService.UserCentricViewController.openConsentInfoModal(id);
                break;
        }
    }

    static url(url) {
        window.open(url, '_blank');
    }
}
